define('responsive-gameday/views/distributors/events/DistributionEvents',{
	UPDATE_ALL: "updateAll",
	UPDATE_PITCHER_CURRENT: "updatePitcherCurrent",
	UPDATE_PITCHER_NEW: "updatePitcherNew",
	UPDATE_BATTER_CURRENT: "updateBCurrentatter",
	UPDATE_BATTER_NEW: "updateBatterNew",
	UPDATE_ATBAT_PITCHES: "updateAtbatPitches",
	UPDATE_ATBAT_EVENT: "updateAtbatEvent",
	UPDATE_ATBAT_CURRENT: "updateAtbatCurrent",
	UPDATE_ATBAT_NEW: "updateAtbatNew",
	UPDATE_GAMESTATE_INNING: "updateGameStateInning",
	UPDATE_GAMESTATE_STATUS: "updateGamestateStatus",
	UPDATE_VIDEO_NEW_HILITE: "updateVideoNewHilite",
	UPDATE_VIDEO_PLAY_LOOKIN: "updateVideoPlayLookin"
});
